import { Utility } from '@/utils'
type Ticket = any // Define the type of 'Ticket' based on your requirements
type Customer = any // Define the type of 'Customer' based on your requirements

type SetTicketFunc = (ticket: Ticket | null, customer: Customer | null) => void
type GetCustomerFunc = () => Customer | null
type GetTicketFunc = () => Ticket | null

const Session = (function () {
    const errorMessage =
        'Session config not set, please call config(setTicketFunc, getCustomerFunc, getTicketFunc)'

    let _setTicketFunc: SetTicketFunc | undefined
    let _getCustomerFunc: GetCustomerFunc | undefined
    let _getTicketFunc: GetTicketFunc | undefined
    let configVars: any

    const config = (
        setTicketFunc: SetTicketFunc,
        getCustomerFunc: GetCustomerFunc,
        getTicketFunc: GetTicketFunc
    ) => {
        _setTicketFunc = setTicketFunc
        _getCustomerFunc = getCustomerFunc
        _getTicketFunc = getTicketFunc
    }

    const set = (ticket: Ticket, customer: Customer) => {
        if (!_setTicketFunc) {
            throw new Error(errorMessage)
        }
        _setTicketFunc(ticket, customer)
    }

    const abandon = () => {
        if (!_setTicketFunc) {
            throw new Error(errorMessage)
        }
        _setTicketFunc(null, null)
    }

    const isAuthenticated = (): boolean => {
        if (!_getTicketFunc) {
            throw new Error(errorMessage)
        }
        return _getTicketFunc() != null
    }

    const customer = (): Customer | null => {
        if (!_getCustomerFunc) {
            throw new Error(errorMessage)
        }
        return _getCustomerFunc()
    }

    const ticket = (): Ticket | null => {
        if (!_getTicketFunc) {
            throw new Error(errorMessage)
        }
        return _getTicketFunc()
    }

    const setUserType = (type: string) => {
        window.sessionStorage.setItem('userType', type)
    }
    const getUserType = () => {
        return window.sessionStorage.getItem('userType')
    }

    const setConfig = (config: any) => {
        configVars = config
    }
    const getConfig = () => {
        return configVars
    }

    const setPoaAccessToken = (token: string) => {
        window.sessionStorage.setItem(
            'poaAccessToken',
            Utility.hexEncode(token)
        )
    }

    return {
        config: config,
        isAuthenticated: isAuthenticated,
        customer: customer,
        ticket: ticket,
        set: set,
        abandon: abandon,
        setUserType: setUserType,
        setPoaAccessToken: setPoaAccessToken,
        getUserType: getUserType,
        setConfig,
        getConfig,
    }
})()

export default Session
